export default function SectionHeading({ eyebrow, title, subtitle, align = "left" }) {
  const isCenter = align === "center";
  return (
    <div className={`max-w-3xl ${isCenter ? "mx-auto text-center" : ""}`}>
      {eyebrow && <span className="eyebrow" data-testid="section-eyebrow">{eyebrow}</span>}
      <h2 className="mt-4 text-4xl sm:text-5xl leading-[1.05]">{title}</h2>
      {subtitle && (
        <p className="mt-4 text-base sm:text-lg text-[color:var(--na-muted)] leading-relaxed">
          {subtitle}
        </p>
      )}
    </div>
  );
}
